export const LOCALES = {
  ENGLISH: 'en-US',
  GERMAN: 'de-DE',
  FRENCH: 'fr-FR',
};
